define('modules/content_recommendations/modal/auto_publish_modal',[
  'backbone',
  '_',
  'text!./auto_publish_modal.html',
], function (Backbone, _, modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'auto-publish-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-auto-publish': 'autoPublish',
    },

    render: function () {
      this.$el.html(this.template({isAutoPublish: this.isAutoPublish}));
      return this;
    },

    autoPublish: function (e) {
      e.preventDefault();
      Backbone.trigger('autopublish', {
        autoPublish: !this.isAutoPublish,
      });
      this.trigger('close');
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

